import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { fill: "currentColor" }, [
  /*#__PURE__*/_createElementVNode("path", { d: "M16 31a15 15 0 1 1 15-15 15 15 0 0 1-15 15m0-28a13 13 0 1 0 13 13A13 13 0 0 0 16 3" }),
  /*#__PURE__*/_createElementVNode("path", { d: "m20.24 21.66-4.95-4.95A1 1 0 0 1 15 16V8h2v7.59l4.66 4.65Z" })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }